module.exports = __webpack_public_path__ + "static/slide-user3-0de187780ecf7bbb82ef4e7f4fcb2c57.png";